import type { Stripe } from 'stripe';
import Log from '$lib/utils/log';

export interface StripePriceData {
	price: Stripe.Price;
	promotionCode?: Stripe.PromotionCode;
}

export async function getPrice(
	lookupKey: string,
	withPromotion = false,
	fetchHandler: typeof fetch = fetch
): Promise<StripePriceData> {
	const searchParams = new URLSearchParams();

	if (withPromotion) {
		searchParams.set('with-promotion', 'true');
	}

	const response = await fetchHandler(`/api/stripe/products/${lookupKey}?${searchParams}`);

	const data = await response.json();

	if (response.status !== 200) {
		Log.scope('Stripe').error('Cannot fetch stripe product', {
			status: response.status,
			statusText: response.statusText,
			data
		});

		throw new Error('Stripe issue');
	}

	return data;
}

export function getPromoOffAmount(
	amount: number,
	{ amount_off, percent_off }: Stripe.Coupon
): number {
	if (amount_off) return amount_off;

	if (percent_off) return (amount * percent_off) / 100;

	return 0;
}

export async function getShippingRate(shippingId: string, fetchHandler: typeof fetch = fetch) {
	const response = await fetchHandler(
		`/api/stripe/shipping${shippingId ? `?shippingId=${shippingId}` : ''}`
	);

	const data = await response.json();

	if (response.status !== 200) {
		Log.scope('Stripe').error('Cannot fetch stripe shipping rate', {
			status: response.status,
			statusText: response.statusText,
			data
		});

		throw new Error('Cannot fetch shipping rate');
	}

	return data;
}
